import React, { useCallback, useState } from 'react';
import { Tooltip } from '@mui/material';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { AlternateCurrencyChipProps } from './AlternateCurrencyChip.props';
import { StyledChipContainer } from './AlternateCurrencyChip.styles';



const AlternateCurrencyChip = (props: AlternateCurrencyChipProps) => {
  const { exchangeRate, sourceCurrency, value, spanId, className, baseCurrency } = props;
  const [isHovered, setIsHovered] = useState(false);

  const showChip = useCallback(() => {
    setIsHovered(true);
  }, []);

  const hideChip = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <span className="value-viewer" onMouseEnter={showChip} onMouseLeave={hideChip}>
      {isHovered && (
        <StyledChipContainer>
          <Tooltip title={`1 ${sourceCurrency} -> ${exchangeRate} ${baseCurrency}`}>
            <Chip label={sourceCurrency} size="small" color="secondary" />
          </Tooltip>
        </StyledChipContainer>
      )}
      <span id={spanId} className={`text-cell ${className}`}>
        {value}
      </span>
    </span>
  );
};

export default AlternateCurrencyChip;
